"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getInfoText;
function getInfoText(application) {
  if (!application.info) return [];
  return application.info.split('\n');
}